import { render, staticRenderFns } from "./OverTablePagination.vue?vue&type=template&id=220a2adf&scoped=true&"
import script from "./OverTablePagination.vue?vue&type=script&lang=js&"
export * from "./OverTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./OverTablePagination.vue?vue&type=style&index=0&id=220a2adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a2adf",
  null
  
)

export default component.exports